// The monthly usage line on Resume Analysis, the Resume Checklist, Mock
// Interview, Elevator Pitch and the CSI results, and the one place that reads
// the usage replies: /resume/usage and /resume/org-check-usage (remaining,
// monthlyLimit), /interview/attempts and /pitch/attempts (remaining,
// maxAttempts), /csi/my-result (used, limit). An account with no monthly limit
// (admins, coaches, employers, org admins) comes back with unlimited: true; its
// numbers are only placeholders, so nothing here ever shows them.

export const isUnlimited = (usage) => usage?.unlimited === true;

// { remaining, limit } for an account with a monthly limit, else null
export function usageLeft(usage) {
    if (!usage || isUnlimited(usage)) return null;
    const limit = usage.monthlyLimit ?? usage.maxAttempts ?? usage.limit;
    if (limit == null) return null;
    // never below 0 (a limit can drop during the month)
    return { remaining: Math.max(0, usage.remaining ?? limit - usage.used), limit };
}

// "2 of 3 analyses remaining this month", "Unlimited analyses", or "- of -"
// while the numbers load
export default function UsageText({ usage, noun, className }) {
    if (isUnlimited(usage)) {
        return <span className={className}><span className="font-medium">Unlimited</span> {noun}</span>;
    }
    const left = usageLeft(usage);
    return (
        <span className={className}>
            <span className="font-medium">{left ? left.remaining : '-'}</span> of {left ? left.limit : '-'} {noun} remaining this month
        </span>
    );
}
